<template>
  <div class="height-input">
    <div class="imperial" v-if="unitSystem === 'imperial'">
      <div class="input-group">
        <div>
          <input inputmode="numeric"
                 pattern="[0-9]*"
                 type="text"
                 v-model.trim="$v.heightImperialFeet.$model"
                 class="text-input inline"
                 :class="{'is-invalid': $v.heightImperialFeet.$error, populated: $v.heightImperialFeet.$model}">

          <span class="input-extra-text">ft</span>

          <div class="input-error" v-if="!$v.heightImperialFeet.required && $v.heightImperialFeet.$dirty">Height is required</div>
          <div class="input-error" v-if="!$v.heightImperialFeet.numeric && $v.heightImperialFeet.$dirty">Must be a number</div>
          <div class="input-error" v-if="!$v.heightImperialFeet.between && $v.heightImperialFeet.$dirty">Must be between <br>{{ $v.heightImperialFeet.$params.between.min }} and {{ $v.heightImperialFeet.$params.between.max }} ft</div>
        </div>

        <div>
          <input inputmode="numeric"
                 pattern="[0-9]*"
                 type="text"
                 v-model.trim="$v.heightImperialInch.$model"
                 class="text-input inline"
                 :class="{'is-invalid': $v.heightImperialInch.$error, populated: $v.heightImperialInch.$model}">

          <span class="input-extra-text">in</span>

          <div class="input-error" v-if="!$v.heightImperialInch.required && $v.heightImperialInch.$dirty">Height is required</div>
          <div class="input-error" v-if="!$v.heightImperialInch.numeric && $v.heightImperialInch.$dirty">Must be a number</div>
          <div class="input-error" v-if="!$v.heightImperialInch.between && $v.heightImperialInch.$dirty">Must be between <br>{{ $v.heightImperialInch.$params.between.min }} and {{ $v.heightImperialInch.$params.between.max }} in</div>
        </div>
      </div>
    </div>

    <div v-else class="metric">
      <input inputmode="numeric"
             pattern="[0-9]*"
             type="text"
             v-model.trim="$v.heightMetric.$model"
             class="text-input inline"
             :class="{'is-invalid': $v.heightMetric.$error, populated: $v.heightMetric.$model}">

      <div class="input-error" v-if="!$v.heightMetric.required && $v.heightMetric.$dirty">Height is required</div>
      <div class="input-error" v-if="!$v.heightMetric.numeric && $v.heightMetric.$dirty">Must be a number</div>
      <div class="input-error" v-if="!$v.heightMetric.between && $v.heightMetric.$dirty">Must be between {{ $v.heightMetric.$params.between.min }} and {{ $v.heightMetric.$params.between.max }} cm</div>

      <span class="input-extra-text">cm</span>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "HeightInput",

  inject: ['$v'],

  computed: {
    ...mapGetters({
      unitSystem: 'userSelections/getUnitSystem',
    }),
  },
};
</script>
